<div appFlex="100%" appFlexLayout="column" class="p-8 h-100-p w-100-p">

  <div appFlex>
    <h4>Add credits to selected Contributors</h4>
  </div>

  <div appFlex appFlexLayout appFlexAlign="end center" class="p-4">
    <span appFlex="grow">Amount</span>
    <dx-number-box
      format="$ #,##0.##"
      [formControl]="fEditExt.get(['amount'])"
    ></dx-number-box>
  </div>

  <div appFlex="grow" appFlexLayout class="p-4">
    <mat-form-field class="w-100-p" appearance="fill">
      <mat-label>Message</mat-label>
      <textarea matInput placeholder="Just say something nice...." [formControl]="fEditExt.get(['message'])"></textarea>
    </mat-form-field>
  </div>

  <div appFlex>
    <span appFlex="auto"></span>
    <button mat-stroked-button [disabled]="fEditExt.invalid" (click)="addCredits()">[Add credits]</button>
  </div>

</div>
